import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux/lib';
import { compose } from "recompose";
import config from 'config';

import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import FaceIcon from '@material-ui/icons/Face';
import GroupIcon from '@material-ui/icons/Group';
import ViewListIcon from '@material-ui/icons/ViewList';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import DateRangeIcon from '@material-ui/icons/DateRange';
import BuildIcon from '@material-ui/icons/Build';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import Avatar from '@material-ui/core/Avatar';
import AssessmentIcon from '@material-ui/icons/Assessment';
import TimelineIcon from '@material-ui/icons/Timeline';
import SettingsIcon from '@material-ui/icons/Settings';
import DashboardIcon from '@material-ui/icons/Dashboard';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';

import owl from "../../images/owl-2.png";
import { checkValue } from '../../_helpers';

const styles = theme => ({
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
});

class MainListItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            selected: null
        };
    }

    handleClick = () => {
        this.setState(state => ({ open: !state.open }));
    };

    updateSelected(selectedIndex) {
        this.setState({ selected: selectedIndex });
    }

    render() {
        const { classes, user } = this.props;
        const { selected } = this.state;

        return (
            <List>
                <ListItem button component={Link} to="/Dashboard" >
                    <ListItemIcon >
                        <Avatar style={{ left: '-5px' }}
                            alt={user.username}
                            src={checkValue(user.avatarUrl) ? `${config.AvatarS3BucketEndpoint}/` + user.avatarUrl + '.png' : owl}
                            imgProps={{ onError: (e) => { e.target.src = owl; } }}
                        />
                    </ListItemIcon>
                    <ListItemText primary={user.username} />
                </ListItem>

                <Tooltip title="Profile" placement="left">
                    <ListItem button component={Link} to="/Profile" onClick={() => this.updateSelected(0)} selected={selected === 0}>
                        <ListItemIcon>
                            <FaceIcon />
                        </ListItemIcon>
                        <ListItemText primary="Profile" />
                    </ListItem>
                </Tooltip>

                <Divider />
                <Tooltip title="Clients" placement="left">
                    <ListItem button component={Link} to="/Clients" onClick={() => this.updateSelected(1)} selected={selected === 1}>
                        <ListItemIcon>
                            <GroupIcon />
                        </ListItemIcon>
                        <ListItemText primary="Clients" />
                    </ListItem>
                </Tooltip>

                <Tooltip title="Projects" placement="left">
                    <ListItem button component={Link} to="/Projects" onClick={() => this.updateSelected(2)} selected={selected === 2}>
                        <ListItemIcon>
                            <ViewListIcon />
                        </ListItemIcon>
                        <ListItemText primary="Projects" />
                    </ListItem>
                </Tooltip>

                <Divider />
                <Tooltip title="Tasks / Issues" placement="left">
                    <ListItem button component={Link} to="/TasksIssues" onClick={() => this.updateSelected(3)} selected={selected === 3}>
                        <ListItemIcon>
                            <AnnouncementIcon />
                        </ListItemIcon>
                        <ListItemText primary="Tasks / Issues" />
                    </ListItem>
                </Tooltip>


                <Tooltip title="Task Diagram" placement="left">
                    <ListItem button component={Link} to="/TasksDiagram" onClick={() => this.updateSelected(4)} selected={selected === 4}>
                        <ListItemIcon>
                            <AssessmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Task Diagram" />
                    </ListItem>
                </Tooltip>

                <Divider />
                <Tooltip title="Timesheet" placement="left">
                    <ListItem button component={Link} to="/Timesheet" onClick={() => this.updateSelected(5)} selected={selected === 5}>
                        <ListItemIcon>
                            <TimelineIcon />
                        </ListItemIcon>
                        <ListItemText primary="Timesheet" />
                    </ListItem>
                </Tooltip>

                <Tooltip title="Time Diagram" placement="left">
                    <ListItem button component={Link} to="/TimeDiagram" onClick={() => this.updateSelected(6)} selected={selected === 6}>
                        <ListItemIcon>
                            <DateRangeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Time Diagram" />
                    </ListItem>
                </Tooltip>

                <Divider />
                <Tooltip title="Settings" placement="left">
                    <ListItem button component={Link} to="/Settings" onClick={() => this.updateSelected(7)} selected={selected === 7}>
                        <ListItemIcon>
                            <SettingsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Settings" />
                    </ListItem>
                </Tooltip>

                <Divider />
                {
                    user.isAdmin
                        ?
                        <Tooltip title="Admin" placement="left">
                            <ListItem button component={Link} to="/Admin" style={{ backgroundColor: '#ffebee' }} onClick={() => this.updateSelected(8)} selected={selected === 8}>
                                <ListItemIcon>
                                    <BuildIcon />
                                </ListItemIcon>
                                <ListItemText primary="Admin" />
                            </ListItem>
                        </Tooltip>
                        :
                        null
                }
                {
                    user.isAdmin
                        ?
                        <div>
                            <Tooltip title="Admin Dashboard" placement="left">
                                <ListItem button onClick={this.handleClick} style={{ backgroundColor: '#ffebee' }}>
                                    <ListItemIcon>
                                        <DashboardIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Security" secondary="Role Security Settings" />
                                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                            </Tooltip>
                            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <Tooltip title="Admin Dashboard - Timesheet" placement="left">
                                        <ListItem button component={Link} to="/AdminDashboardTimesheet" className={classes.nested} style={{ backgroundColor: '#ffebee' }} onClick={() => this.updateSelected(9)} selected={selected === 9}>
                                            <ListItemIcon>
                                                <DashboardIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Admin Dashboard - Timesheet" />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Admin Dashboard - Project" placement="left">
                                        <ListItem button component={Link} to="/AdminDashboardProject" className={classes.nested} style={{ backgroundColor: '#ffebee' }} onClick={() => this.updateSelected(10)} selected={selected === 10}>
                                            <ListItemIcon>
                                                <DashboardIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Admin Dashboard - Project" />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Admin Dashboard - Settings" placement="left">
                                        <ListItem button component={Link} to="/AdminDashboardSettings" className={classes.nested} style={{ backgroundColor: '#ffebee' }} onClick={() => this.updateSelected(11)} selected={selected === 11}>
                                            <ListItemIcon>
                                                <DashboardIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Admin Dashboard - Settings" />
                                        </ListItem>
                                    </Tooltip>
                                </List>
                            </Collapse>
                        </div>
                        :
                        null
                }

                <Divider />
            </List>
        )
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    return {
        user
    };
}

export default compose(connect(mapStateToProps), withStyles(styles))(MainListItems);


// WEBPACK FOOTER //
// ./src/components/Homepage/listItems.js